import Swal from "sweetalert2";
import { getCsrfToken } from "@phoarau/ts_sysop_utils";

$(function () {
    $("#formPasswordRecovery").on("submit", function (event) {
        event.preventDefault();
        sendPasswordRecovery(String($("#email").val() ?? ""));
    });
});

function sendPasswordRecovery(email: string): void {
    $.ajax({
        url: "/users/forgotPassword.json",
        data: {
            email: email,
        },
        type: "POST",
        cache: false,
        headers: {
            "X-CSRF-Token": getCsrfToken(),
        },
        dataType: "json",
        success: function (json) {
            if (json) {
                if (json.status === 0) {
                    $("#email").val("");
                    Swal.fire("Succès", json.message, "success");
                } else {
                    Swal.fire("Erreur lors de l'enregistrement", json.message, "error");
                }
            }
        },
        error: function (error) {
            console.error(error);
        },
    });
}
